import React, { useState, useRef } from 'react'
import { Button, Tab, Tabs, styled } from '@mui/material'
import { TabContext, TabPanel } from '@mui/lab';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { resetAllData, updateCurrentTab } from '../../../../../stateManagement/actions/manageCouponActions';
import { LAST_TAB, labelMappings } from '../../../utils/utils';
import KOCalendar from './KOCalendar';
import NormalCalendar from './NormalCalendar';

interface SkipThisStepProps {
    onClick: () => void
}
function SkipThisStep({ onClick }: SkipThisStepProps) {
    const [isHovered, setIsHovered] = useState(false);
    const spanStyle = {
        textDecoration: 'underline',
        fontSize: '13px',
        color: isHovered ? '#1e1e1e80' : '#5A5A5A80',
        cursor: 'pointer',
        padding: '10px',
    };
    return (
        <span
            style={spanStyle}
            onMouseOver={() => setIsHovered(true)}
            onMouseOut={() => setIsHovered(false)}
            onClick={onClick}
        >Skip This Step</span>
    )
}

export default SkipThisStep;